import React from 'react';
import { Box, Container, Typography } from "@mui/material";
import PlansCardListing from "./plans_card_listing";
const Plans = ()=>{
    return(
        <Container maxWidth={false}
            sx={{
                backgroundColor: "#000000",
            }}
        >
            <Container 
                sx={{
                    height:"auto",
                    padding: {xs:"20px 20px",md:"80px 40px",lg:"80px 0px"},
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <Box
                    color="white"
                >
                    <Typography
                        variant="h3"
                        textAlign="center"
                        gutterBottom
                        sx={{
                            fontSize: {xs:"18px",sm:"28px",md:"34px",lg:"48px"},
                            fontWeight: "700",
                            width:"100%",
                            textTransform: "uppercase"
                            // backgroundColor: "red",
                        }}
                    >Subscribtion Plans</Typography>
                    <Typography
                        gutterBottom
                        variant="subtitle2"
                        component="p"
                        fontFamily="Times New Roman"
                        textAlign="center"
                        sx={{
                            fontSize: {xs:"14px",md:"20px"},
                            lineHeight: {xs:"18px",sm:"26px",md:"28px"},
                            pl:{md:"20px"}
                        }}
                    >
                        Choose the best plan that suits your needs, whether you’re an 
                        individual student or a consultancy. Our packages offer comprehensive 
                        features to enhance your test preparation experience.
                    </Typography>
                </Box>
                <PlansCardListing />
            </Container>
        </Container>
    );
}
export default Plans;